<template>
    <div>
        <message-component id="message" v-model="isMessage" :success="this.message.success" style="white-space:pre-wrap; word-wrap:break-word;">{{ message.text }}</message-component>
        <v-overlay :value="sending" z-index="10000">
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            <span class="loading">処理中です...</span>
        </v-overlay>
        
        <validation-observer ref="observer" v-slot="{ valid }" >
            <v-card class="mx-auto" width="1000" min-width="1000" color="#F4FEFB">
                <v-card-text>
                    <pdf-upload-component @triggerEvent="changeFile" @triggerEvent2="deleteDbFile" :db-file-list="items" :edit="true"></pdf-upload-component>
                    <v-container>
                        <v-row>
                            <v-col cols="12" xl="3">
                                <badge-component color="red" tile content="必 須">
                                    <label-component>タイトル</label-component>
                                </badge-component>
                            </v-col>
                            <v-col cols="12" xl="7">
                                <validation-provider v-slot="{ errors }" name="stateContractName" rules="required|max:50">
                                    <v-text-field placeholder="契約書タイトルを入力してください" outlined clearable v-disabled-icon-focus :error-messages="errors" v-model="stateContractName" background-color="white"></v-text-field>
                                </validation-provider>
                            </v-col>
                        </v-row>
                        <!--<v-row>-->
                        <!--    <v-col cols="12" xl="3">-->
                        <!--        <badge-component color="grey darken-1" content="?" enableClick>-->
                        <!--            <badge-component tile content="任　意" ><label-component>メモ</label-component></badge-component>-->
                        <!--        </badge-component>-->
                        <!--    </v-col>-->
                        <!--    <v-col cols="12" xl="7">-->
                        <!--        <validation-provider v-slot="{ errors }" name="stateMemo" rules="max:10000" >-->
                        <!--            <v-textarea auto-grow outlined clearable v-disabled-icon-focus rows="3" placeholder="取引先の会社名などを入力してください" :error-messages="errors" v-model="stateMemo" background-color="white"></v-textarea>-->
                        <!--        </validation-provider>-->
                        <!--    </v-col>-->
                        <!--</v-row>-->
                    </v-container>
                </v-card-text>
            </v-card>
            <div class="text-center pt-2">
                <v-btn color="red" class="white--text" :disabled="!(isValid&&valid)" @click="next">次へ</v-btn>
            </div>
        </validation-observer>
    </div>
</template>

<script>
    import axios from 'axios';
    import { required, max } from 'vee-validate/dist/rules';
    import { extend, ValidationObserver, ValidationProvider } from 'vee-validate';
    
    extend('required', {...required, message: '入力必須項目です',});
    extend('max', {
        ...max,
        message: '{length} 文字以内でご入力ください',
    });
    
    export default {
        components: {
              ValidationProvider,
              ValidationObserver,
        },
        props: {
            model: Object,
            dbFileList: Array,
        },
        data() {
            return {
                files: [],
                items: [],
                objectIds: [],
                stateContractName: '',
                stateMemo: '',
                message: {
                    success: false,
                    text: '',
                },
                sending: false,
            };
        },
        // 初期表示のデータ
        created : function() {
            this.items = this.dbFileList;
            this.stateContractName = this.model.contract_name;
            this.stateMemo = this.model.memo;
        },
        computed: {
            isMessage: {
                get() {
                    return this.message.text != '';
                },
                set(value) {
                    if (!value) {
                        this.message.text = '';
                    }
                }
            },
            isValid: {
                get() {
                    if (this.stateContractName == null) {
                        return false;
                    }
                    
                    if (this.stateContractName.length <= 0 || this.stateContractName.length > 50) {
                        return false;
                    }
                    
                    if (this.stateMemo != null && this.stateMemo.length > 10000) {
                        return false;
                    }
                    
                    if (this.items.length <= 0 && this.files.length <= 0) {
                        return false;
                    }
                    
                    return true;
                },
                set(value) {
                    
                }
            }
        },
        methods: {
            next: async function() {
                this.sending = true;
                try {
                    let result = await this.save();
                    if (result) {
                        window.location = "address";
                    }
                }
                finally {
                    this.sending = false;
                }
            },
            
            // 保存
            save: async function(draft = null) {
                var self = this;
                let result = false;
                await this.$refs.observer.validate().then( async function(validOk) {
                    if(validOk) {
                        let formData = new FormData();
                        for(let i = 0; i < self.files.length; i++){
                            formData.append('files[]', self.files[i][0].file);
                            formData.append('file_names[]', self.files[i][0].file_name);
                        }
                        //JSON文字列に変換
                        formData.append('contractItems', JSON.stringify(self.items));
                        formData.append('contract_name', self.stateContractName);
                        formData.append('memo', self.stateMemo);
                        formData.append('draft', draft);
                        
                        let config = {
                            headers: {
                                'content-type': 'multipart/form-data'
                            }
                        };
                        
                        await axios
                            .post('info', formData, config)
                            .then(function (response) {
                                if (response.data.success) {
                                    result = true;
                                    self.stateContractName = response.data.agreement.contract_name;
                                    self.stateMemo = response.data.agreement.memo;
                                    self.items = response.data.dbFileList;
                                    self.files.splice(0, self.files.length);
                                } 
                                else {
                                    result = false;
                                    if (response.data.message) {
                                        self.message.text = response.data.message;
                                    } else {
                                        self.message.text = "保存処理に失敗しました";
                                    }
                                    self.message.success = false;
                                }
                            })
                            .catch(function (response) {
                                result = false;
                                console.log(response);
                                self.message.text = "保存処理に失敗しました";
                                self.message.success = false;
                            }
                        );
                    } else {
                        result = false;
                        self.message.text = "入力項目に不備があります";
                        self.message.success = false;
                    }
                });
                return result;
            },
            changeFile: function(value) {
                this.files = value;
            },
            
            deleteDbFile: function(index) {
                this.$delete(this.items, index);
            }
        },
    };
</script>
